import React from 'react'
import { useLocation } from 'react-router-dom'

const breadcrumbMap = {
  '/dashboard': ['Dashboard'],
  '/dashboard-old': ['Dashboard', 'Legacy Dashboard'],
  '/match-event': ['Match Event'],
  '/odds-hub': ['Odds', 'Odds Hub'],
  '/check-odd': ['Odds', 'Check Odd'],
  '/diff-odd': ['Odds', 'Different Odd'],
  '/goal-result': ['Result', 'Goal Result'],
  '/result-hub': ['Result', 'Result Hub'],
  '/insert-result': ['Result', 'Insert Result'],
  '/update-result': ['Result', 'Recalculation'],
  '/diff-odd-vouchers': ['Reports', 'Different Odd Vouchers'],
  '/win-lose': ['Reports', 'Win/Lose'],
  '/report-byevent': ['Reports', 'Event Risk'],
  '/report-bymix': ['Reports', 'Mix Exposure'],
  '/report-bypurchased': ['Reports', 'Hedge/Purchase'],
  '/transaction-bydate': ['Transaction', 'User Transaction'],
  '/balance-transfer': ['Transaction', 'Balance Transaction'],
  '/user-control': ['User Hub', 'User Control'],
  '/live-betting-control': ['Betting Hub', 'Outstanding'],
  '/gambling-limit': ['Betting Hub', 'Limit'],
  '/league-selection': ['Selection Hub', 'League Selection'],
  '/buffer-zone': ['Selection Hub', 'Buffer Zone'],
  '/live-event-control': ['Selection Hub', 'Event Control'],
  '/settings': ['Settings'],
  '/single': ['Reports', 'Single Bet by Event'],
  '/by-voucher': ['Reports', 'By Voucher'],
  '/voucher-explorer': ['Result and Voucher Control', 'Voucher Explorer'],
  '/menu-list': ['User Hub', 'Menu List'],
}

const formatPathSegment = (segment) =>
  segment
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

const PageBreadcrumb = () => {
  const { pathname } = useLocation()
  const normalizedPath = pathname.replace(/\/+$/, '').toLowerCase() || '/'
  const fallbackLabel = formatPathSegment(normalizedPath.split('/').filter(Boolean).pop() || 'Home')
  const items = breadcrumbMap[normalizedPath] || [fallbackLabel]

  return (
    <nav
      aria-label="Breadcrumb"
      className="px-2 pt-3 text-sm text-customSecondaryText dark:text-customMuted lg:px-4 bg-transparent"
    >
      <ol className="flex min-h-6 flex-wrap items-center gap-2">
        {items.map((item, index) => {
          const isCurrentPage = index === items.length - 1

          return (
            <React.Fragment key={`${item}-${index}`}>
              {index > 0 && <li aria-hidden="true">/</li>}
              <li
                aria-current={isCurrentPage ? 'page' : undefined}
                className={
                  isCurrentPage
                    ? 'font-semibold text-customPrimaryText dark:text-customHeading'
                    : 'font-semibold text-customAccentBlue dark:text-customAccent'
                }
              >
                {item}
              </li>
            </React.Fragment>
          )
        })}
      </ol>
    </nav>
  )
}

export default PageBreadcrumb
